import type { ReactNode } from 'react';
import { isWebUrl } from './ExternalLink';
import styles from './ui.module.css';

/**
 * Карточка-ссылка наружу: значок слева, адрес во всю оставшуюся ширину.
 *
 * Нажимается целиком. Подписью это было плохо: адрес — одно длинное слово, по
 * нему трудно попасть пальцем, и перенос рвал его посреди строки. Контур
 * бирюзовый, как у всего, что ведёт наружу и работает.
 *
 * Адрес пишут люди, а React 18 `javascript:` в `href` не режет: не http(s) —
 * та же карточка, но без ссылки.
 */
export function LinkCard({
  href,
  icon,
  children,
}: {
  href: string;
  icon: ReactNode;
  children: ReactNode;
}) {
  const content = (
    <>
      {icon}
      <span className={styles.linkCardText}>{children}</span>
    </>
  );

  const web = isWebUrl(href);
  if (!web) return <div className={styles.linkCard}>{content}</div>;

  return (
    <a className={styles.linkCard} href={href} target="_blank" rel="noopener noreferrer">
      {content}
    </a>
  );
}
